import Vue from 'vue'

export default {
  getDealer: function ({dealerId}) {
    let apiDetailPath = '/dealers/' + dealerId
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { 'headers': {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  registerDealer: function ({dealerId, name, zip, address1, address2, phone, email, lat, lng}) {
    let apiDetailPath = '/dealers/' + dealerId + '/register'
    let data = {
      company_name: name,
      company_zipcode: zip,
      company_address1: address1,
      company_address2: address2,
      company_phone: phone,
      company_email: email,
      lat: lat,
      lng: lng
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  updateDealer: function ({dealerId, name, zip, address1, address2, phone, email, lat, lng}) {
    let apiDetailPath = '/dealers/' + dealerId
    let data = {
      company_name: name,
      company_zipcode: zip,
      company_address1: address1,
      company_address2: address2,
      company_phone: phone,
      company_email: email,
      lat: lat,
      lng: lng
    }
    return Vue.http.put(Vue.env.apiPath + apiDetailPath, data, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  },
  acceptDealerMemberInvitation: function ({dealerId, memberId}) {
    let apiDetailPath = '/dealers/' + dealerId + '/members/' + memberId + '/accept'
    return Vue.http.get(Vue.env.apiPath + apiDetailPath, { headers: {'Authorization': 'Bearer ' + Vue.auth.idToken} })
  }
}



// WEBPACK FOOTER //
// ./src/apis/dealer.js